// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import {userAddSettleItem,userId} from '../../actions/userActions';
import { connect } from 'react-redux';
import AddEditForm from '../../components/user/SettleForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants} from "../../constants";
import {list as bankList} from '../../containers/financial/BankListPage';


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.user.getItem,
        userValue: state.app.currentUser,
        bankList  : state.financial.bankList,
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getBankList : () => {
        return(dispatch(bankList()));
    },
    setUserId: (id) => {
        return(dispatch(userId(id)))
    },

    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(add(value));
    },

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const add = (values,mode) => {
    return (dispatch, getState) => {
        let states = getState()
        let userId;

        if(states.user.userId)
            userId = states.user.userId

        else{
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'تکنسین وجود ندارد'
            })
        }

        var formData = {
            'technician'       : userId,
            'bank_account' : values.bank_account,
        };

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.post('order/tech/settle', formData).then(list => {
            // dispatch(userAddSettleItem(list.data.lists));
            if(list.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS})
                if(list.data.is_settled) {
                    dispatch({
                        type: alertConstants.SUCCESS,
                        message: `عملیات شما با موفقیت انجام شد\r\nمبلغ ${list.data['amount']} برای تکنسین واریز شد`
                    })
                    setTimeout(() => dispatch({type: commonConstants.PAGE_REDIERCT, redirectTo: '/order/list/technician/'+userId}), 100)
                } else {
                    if(list.data.has_unsettled_order) {
                        dispatch({
                            type: alertConstants.ERROR,
                            message: `این تکنسین فاکتور تسویه نشده دارد`
                        })
                    } else {
                        dispatch({
                            type: alertConstants.ERROR,
                            message: `خطا در انجام عملیات تسویه`
                        })
                    }
                }
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddEditForm);
